import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import CsApiSettings from '../components/CsApiSettings';

const CsApiSettingsPage: React.FC = () => (
  <Container maxWidth="lg" sx={{ py: 4 }}>
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        CS AI API
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Kelola API key untuk integrasi aplikasi Customer Service AI
      </Typography>
    </Box>
    <CsApiSettings />
  </Container>
);

export default CsApiSettingsPage;
